import { arrayToMap, arrayToObject, groupBy, isNonNullable, unique, uniqueBy } from 'lib/array/arrayUtils'
import { isBundleOffer } from 'lib/offer/offerTypes'

/** Keep request expansion and ownership aligned with the calendars the API can map. */
export default function getCalendarRequestPackages(offer: App.HotelOffer | App.HotelOfferSummary, packages: Array<App.HotelPackage>) {
  const packageLookupSource = uniqueBy([...offer.packages, ...packages], pkg => pkg.uniqueKey)
  const packagesByUniqueKey = arrayToMap(packageLookupSource, pkg => pkg.uniqueKey)
  const packageGroups = groupBy(packages, pkg => pkg.duration)
  const bundled = isBundleOffer(offer)
  if (!bundled) {
    packageGroups.forEach((pkgGroup, duration) => {
      const targetUpgradePackagesUniqueKeys = pkgGroup.flatMap(pkg => [pkg.loyalty.upgradeTargetsUniqueKeys?.room, pkg.loyalty.upgradeTargetsUniqueKeys?.package]).filter(isNonNullable)
      const targetUpgradePackages = targetUpgradePackagesUniqueKeys.map(uniqueKey => offer.packages.find(pkg => pkg.uniqueKey === uniqueKey)).filter(isNonNullable)
      packageGroups.set(duration, unique([...targetUpgradePackages, ...pkgGroup]))
    })
  }
  const responsePackageKeys = new Set<string>()
  const bundledDurations = bundled ? new Set(Object.values(arrayToObject(packages, pkg => pkg.offerId, pkg => pkg.duration))) : undefined
  const bundledPackageIds = bundled ? new Set(packages.map(pkg => pkg.id)) : undefined
  packageGroups.forEach((pkgGroup, duration) => {
    const packageIds = new Set(pkgGroup.map(pkg => pkg.id))
    packageLookupSource.forEach(pkg => {
      // svc-calendar returns all rates for each requested package ID and duration.
      // Only rates present in the API's lookup can survive its final mapping.
      if (bundled
        ? bundledPackageIds?.has(pkg.id) && bundledDurations?.has(pkg.duration)
        : packageIds.has(pkg.id) && pkg.duration === duration) {
        responsePackageKeys.add(pkg.uniqueKey)
      }
    })
  })
  return { packagesByUniqueKey, packageGroups, responsePackageKeys: Array.from(responsePackageKeys) }
}
